var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"partnerAcademy"}},_vm._l((_vm.tableData),function(item,index){return _c('academy',{key:index,attrs:{"bgSrc":item.background,"academyName":item.name,"academyContent":item.content,"color":item.type,"flexDirection":item.position}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }